import { GetBrokerAssociate_getBrokerAssociate } from '_graphql/queries/__generated__/GetBrokerAssociate'
import { Avatar } from 'components/core'
import _ from 'lodash'
import { FC } from 'react'

type Props = {
    associate: GetBrokerAssociate_getBrokerAssociate | null | undefined
}

const BrokerRepView: FC<Props> = ({ associate }) => {
    return (
        <div className="space-y-6 divide-y divide-gray-200">
            <div>
                <span className='text-xs font-light'>Company Information</span>
                <div className='grid grid-cols-3 gap-6 mt-2'>
                    <div className='row-span-2 flex flex-col space-y-3 items-center justify-center'>
                        <Avatar
                            alt={associate?.re_broker_assoc_first_name + " " + associate?.re_broker_assoc_last_name || "N A"}
                            size="xl"
                        />
                    </div>
                    <div className='col-span-3'>
                        <span className="block text-sm font-light text-gray-700">
                            Full Name
                        </span>
                        <div className="mt-1 block w-full sm:text-sm">
                            {associate?.re_broker_assoc_first_name || "N/A"} {associate?.re_broker_assoc_last_name || "N/A"}
                        </div>
                    </div>
                </div>
            </div>
            <div className='pt-6'>
                <span className='text-xs font-light'>Contact Information</span>
                <div className='grid grid-cols-2 gap-6 mt-2'>
                    <div>
                        <span className="block text-sm font-light text-gray-700">
                            Email Address
                        </span>
                        <div className="mt-1 block w-full sm:text-sm">
                            {associate?.re_broker_assoc_email || "N/A"}
                        </div>
                    </div>

                    <div className=''>
                        <span className="block text-sm font-light text-gray-700">
                            Phone Number
                        </span>
                        <div className="mt-1 block w-full sm:text-sm">
                            {[associate?.re_broker_assoc_primary_phone, associate?.re_broker_assoc_secondary_phone].join(", ") || "N/A"}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BrokerRepView